var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvent3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 64,
    viewBox: "0 0 45 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_4004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9999 64.0001C41.8129 62.2636 40.058 61.1865 37.405 60.0681C31.8057 57.7019 36.2723 55.0826 30.6671 50.8092C18.9461 41.8623 20.5484 37.5948 11.2455 28.4949C4.68951 22.0731 -5.34701 8.81161 3.44522 0.576904C9.97189 0.465067 15.4362 -2.28965 18.5939 5.32702L23.1133 16.234C24.921 16.2164 26.5703 16.287 27.6972 16.6284C28.783 18.5296 27.48 22.6911 25.2908 22.3026C23.9115 22.0613 22.497 21.3609 21.5814 22.1261C23.5593 26.5112 25.596 30.2018 28.3487 33.7924C34.0067 41.1677 38.3676 49.2965 42.8987 57.5018C43.9493 59.4089 44.4776 61.3866 44.9882 64.0059L44.9999 64.0001ZM19.4156 13.9267C18.7172 8.68212 16.2814 5.06214 13.3761 1.76002L11.5038 1.45394C11.1458 1.39508 10.8171 2.278 10.5999 2.78421L19.4156 13.9326V13.9267ZM11.2338 25.6695C15.8236 26.5878 19.6269 24.7748 19.6328 20.1307L11.2338 25.6695ZM40.5158 58.0668C39.4006 55.5181 38.3911 53.9936 36.1079 52.1689C35.3919 53.8229 35.5973 55.3121 36.4601 56.5482C37.1468 57.5371 38.6669 58.108 40.5158 58.0668Z",
    fill: "#1A202E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_4004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent3);
export default __webpack_public_path__ + "static/media/event3.9f4329826e87270106a06d77ee3f1236.svg";
export { ForwardRef as ReactComponent };